import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const Icon3dBoxTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-Icon3dBoxTop"><Path d="M11.25 12.4326V22.6826L2.37305 17.5576V7.30762L11.25 12.4326Z" fill="currentColor"/><Path d="M21.627 17.5576L12.75 22.6826V12.4326L21.627 7.30762V17.5576Z" fill="currentColor"/><Path d="M20.876 6.00879L12 11.1338L3.12305 6.00879L12 0.883789L20.876 6.00879Z" fill="currentColor"/></CentralIconBase>;
});

export default Icon3dBoxTop;
